import { useContext, useEffect, useState } from "react";
import Wrapper from "../../../../components/common/Wrapper/Wrapper";
import organisms from "../../../../components/organisms";
import { HeaderHeading } from "../../../../Context";
import { LostBarcodeProps } from "./interface";
import { useLostBarcodeLogic } from "./hook/useLostBarcodeLogic";
import atoms from "../../../../components/atoms";
import { useSearchParams } from "react-router-dom";
import { getParams } from "../../../../constants/utils";
import constant from "../../../../constants/constant";

const { BulkLostBarcode } = organisms;
const { AppLoader } = atoms;

const Index = () => {
  
  const [searchParams] = useSearchParams();
  const { handleFileUpload, handleSubmit } = useLostBarcodeLogic();
  const [typeValue, setTypeValue] = useState<boolean>(getParams('bulk-lost-barcode-type') == constant.BRAND_CATEGORY[0]?.value)
  
  const [lostBarcodeData, setLostBarcodeData] = useState<LostBarcodeProps[]>(
    []
  );
  const [erroredBarcode, setErroredBarcode] = useState<LostBarcodeProps[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { setHeader, setSidebar }: any = useContext(HeaderHeading);

  // INFO:- to set the name of page in header
  useEffect(() => {
    setHeader("Barcode - Bulk Lost Barcode");
  }, []);

  useEffect(() => {
    setLostBarcodeData([])
    setErroredBarcode([])
    let tempValue: any = getParams('bulk-lost-barcode-type')
    setTypeValue(tempValue == constant.BRAND_CATEGORY[0]?.value)
  }, [searchParams.get("bulk-lost-barcode-type")]);
  // end

  return (
    <Wrapper>
      <div className="col">
        <BulkLostBarcode
          erroredBarcode={erroredBarcode}
          lostBarcodeData={lostBarcodeData}
          handleFileUpload={(e) =>
            handleFileUpload({
              e,
              setIsLoading,
              setLostBarcodeData,
              setErroredBarcode,
            })
          }
          handleSubmit={() =>
            handleSubmit({
              excelData: lostBarcodeData,
              setIsLoading,
              setErroredBarcode,
              is_recognised:typeValue,
              setLostBarcodeData:(value:LostBarcodeProps[])=>setLostBarcodeData(value)
            })
          }
        />
      </div>
      {isLoading && <AppLoader />}
    </Wrapper>
  );
};

export default Index;
